import React from 'react';
import { Linkedin, Youtube, Instagram } from 'lucide-react';
import { SOCIAL } from '../../data/content';

const LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Training', href: '#training' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Hall of Fame', href: '#blog' },
  { label: 'Contact', href: '#contact' },
];

const SOCIALS = [
  { key: 'linkedin', Icon: Linkedin, href: SOCIAL.linkedin, color: '#0A66C2' },
  { key: 'youtube', Icon: Youtube, href: SOCIAL.youtube, color: '#FF0000' },
  { key: 'instagram', Icon: Instagram, href: SOCIAL.instagram, color: '#E1306C' },
];

export default function Footer() {
  const handle = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative pt-24 pb-10 border-t border-white/5 bg-black/40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16">
          <h3 className="font-display font-black text-6xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.9]">
            LET'S<br />
            <span className="text-teal">BUILD.</span>
          </h3>
        </div>

        <div className="grid md:grid-cols-12 gap-10 pb-10 border-b border-white/5">
          <div className="md:col-span-5">
            <div className="font-display font-black text-lg text-white mb-3">PARTH.SHARMA</div>
            <p className="text-white/55 text-sm max-w-sm">
              Training AI Practitioners Since 2016.
            </p>
            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
              @beardandbinary
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Navigate</p>
            <ul className="flex flex-col gap-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => handle(e, l.href)}
                    className="text-white/75 hover:text-teal transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Connect</p>
            <div className="flex flex-wrap gap-3">
              {SOCIALS.map(({ key, Icon, href, color }) => (
                <a
                  key={key}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={key}
                  data-testid={`footer-social-${key}`}
                  className="w-10 h-10 rounded-xl bg-white/[0.06] border border-white/10 flex items-center justify-center text-white/60 hover:scale-110 transition-all"
                  onMouseEnter={(e) => { e.currentTarget.style.color = color; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = ''; }}
                >
                  <Icon size={17} strokeWidth={1.75} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
          <div>© 2026 Parth Sharma. All rights reserved.</div>
          <div>Privacy · Terms · Berlin, DE</div>
        </div>
      </div>
    </footer>
  );
}
